import { BankFilePayment } from '@payer-admin-ui/api/src/bankfilepayments/bankFilePaymentTypes';
import {
  AppEntityState,
  FetchingEntityState,
  ListViewWithFilterAndMultiSortState,
  SingleViewState,
} from '@payer-admin-ui/components-v2/src/types/state';

export type BankFilePaymentFilters = {
  bankAccountTypes: string[];
  processingDateStart: string;
  processingDateEnd: string;
  bookingDateStart: string;
  bookingDateEnd: string;
  name: string;
  id: string;
  fullyMapped: string[];
  manuallyMapped: boolean | null;
  toPayer: string[];
  doNotMap: string[];
  search: string;
  doNotMapReasons: string[];
  customer: string;
  fundSourceTypes: string[];
};

export enum BankFilePaymentsSortableColumn {
  id = 'id',
  amount = 'amount',
  bankAccountNumber = 'bankAccountNumber',
  debtor = 'debtor',
  ultimateDebtor = 'ultimateDebtor',
}

export type BankFilePaymentsGridSortableColumn = BankFilePaymentsSortableColumn | 'customerName';

export const bankFilePaymentsSortMappings: Record<
  BankFilePaymentsGridSortableColumn,
  BankFilePaymentsSortableColumn[]
> = {
  id: [BankFilePaymentsSortableColumn.id],
  amount: [BankFilePaymentsSortableColumn.amount],
  bankAccountNumber: [BankFilePaymentsSortableColumn.bankAccountNumber],
  debtor: [BankFilePaymentsSortableColumn.debtor],
  ultimateDebtor: [BankFilePaymentsSortableColumn.ultimateDebtor],
  customerName: [BankFilePaymentsSortableColumn.ultimateDebtor, BankFilePaymentsSortableColumn.debtor],
};

export type BankFilePaymentRowEntity = BankFilePayment & {
  customerName: string;
};

export type BankFilePaymentEntity = FetchingEntityState<BankFilePayment, string> & {
  backoffice?: { isFetching: boolean; error: any };
};

export type BankFilePaymentsGlobalState = AppEntityState<any, string> &
  SingleViewState<string> &
  ListViewWithFilterAndMultiSortState<string, BankFilePaymentFilters, BankFilePaymentsSortableColumn> & {
    listView: {
      summary?: any[];
      inited: boolean;
      filterOverride: BankFilePaymentFilters | null;
    };
  };
